<div class="student-invites-content">
  <h2 class="confirm title header-text heavy-header-text" mat-dialog-title>
    Invite Multiple Students
  </h2>
  <mat-dialog-content>
    <div class="col mb-1">
      <p>
        Download the template file and add a row per student in your classroom.
      </p>
      <div class="flex justify-center">
        <a
          mat-raised-button
          class="download-button"
          color="primary"
          download="student-upload.csv"
          href="assets/documents/student-upload.csv"
          target="_blank"
        >
          <span>Template File</span>
          <mat-icon>download</mat-icon>
        </a>
      </div>
      <p>Then upload the file to invite students to the classroom.</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-center">
    <form [formGroup]="form" (ngSubmit)="submit($event)">
      <input
        class="mb-1"
        type="file"
        name="file"
        id="file"
        formControlName="file"
      />
      <app-confirm-cancel
        [buttonConfig]="buttonConfig"
        [disableSubmit]="submitDisabled"
      >
      </app-confirm-cancel>
    </form>
  </mat-dialog-actions>
</div>
